var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_125_30498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 29.9997C23.2841 29.9997 29.9997 23.2841 29.9997 14.9999C29.9997 6.71567 23.2841 0 14.9999 0C6.71567 0 0 6.71567 0 14.9999C0 23.2841 6.71567 29.9997 14.9999 29.9997Z",
    fill: "#444444",
    fillOpacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5658 10.4206C23.0227 10.6615 22.4384 10.8243 21.8257 10.8971C22.4513 10.5223 22.9314 9.92923 23.158 9.22141C22.5726 9.56865 21.924 9.82056 21.2343 9.95634C20.6816 9.36781 19.8943 9 19.0225 9C17.3497 9 15.993 10.3567 15.993 12.0294C15.993 12.2669 16.0199 12.498 16.0719 12.7199C13.5542 12.5936 11.3218 11.3876 9.82754 9.55419C9.56682 10.0015 9.41726 10.5223 9.41726 11.0774C9.41726 12.1282 9.95247 13.0558 10.7649 13.5989C10.2685 13.5833 9.8011 13.4471 9.39286 13.2196C9.39263 13.2325 9.39263 13.2454 9.39263 13.258C9.39263 14.7258 10.4373 15.9501 11.8229 16.2282C11.569 16.2978 11.3008 16.3347 11.0249 16.3347C10.8293 16.3347 10.6397 16.3159 10.4549 16.2807C10.8404 17.4839 11.9589 18.3598 13.2849 18.3845C12.2479 19.1971 10.9418 19.6813 9.52209 19.6813C9.27809 19.6813 9.03635 19.667 8.7998 19.6388C10.1398 20.4987 11.7325 21 13.4432 21C19.0154 21 22.0627 16.3839 22.0627 12.3803C22.0627 12.249 22.0598 12.1182 22.0539 11.9885C22.6463 11.5615 23.1598 11.0281 23.5658 10.4206Z",
    fill: "#F1F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_125_30498",
    x: -1.2,
    y: -1.2,
    width: 32.3995,
    height: 32.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_125_30498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_125_30498",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.2b9c00b180e3dc6b6a8781a064d8ffa7.svg";
export { ForwardRef as ReactComponent };